import flatpickr from 'flatpickr';
import { Czech } from 'flatpickr/dist/l10n/cs';
import merge from 'deepmerge';
import { iconSVG } from '../tools/utils';
import { addClass, hasClass, append } from '../tools/DOM';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-datepicker')];

	const OPTIONS = {
		prevArrow: iconSVG('angle-l'),
		nextArrow: iconSVG('angle-r'),
		time_24hr: true,
		locale: Czech,
		animate: false,
		altInput: true,
		altFormat: 'j. F Y',
		minuteIncrement: 10,
		disableMobile: true,
	};

	const init = (element) => {
		const optionsData = element.getAttribute('data-options');
		const options = optionsData ? JSON.parse(optionsData)[0] : {};
		const datepicker = flatpickr(element, merge(OPTIONS, options.options ? options.options : {}));

		if (datepicker.timeContainer) {
			const timeArrows = [...datepicker.timeContainer.querySelectorAll('.arrowUp, .arrowDown')];
			const { hours, minutes } = options.labels;
			const hourElement = datepicker.hourElement;
			const minuteElement = datepicker.minuteElement;
			const hourLabel = document.createElement('span');
			const minuteLabel = document.createElement('span');

			addClass(hourLabel, 'label');
			addClass(minuteLabel, 'label');
			hourLabel.textContent = hours;
			minuteLabel.textContent = minutes;

			append(hourLabel, hourElement.parentNode);
			append(minuteLabel, minuteElement.parentNode);

			timeArrows.forEach((element) => {
				let icon;

				hasClass(element, 'arrowDown') ? icon = 'angle-d' : icon = 'angle-u';

				element.innerHTML = iconSVG(icon);
			});
		}

		return datepicker;
	};


	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/datepicker.js